(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog-contextual/assets/javascripts/contextual-dialog.js') >= 0) return;  svs.modules.push('/components/components/dialog-contextual/assets/javascripts/contextual-dialog.js'); 
'use strict';

const {
  createPopper
} = Popper;
svs.components.dialog.branding.NAVY = 'navy';

class DialogContextual extends svs.components.dialog.Confirm {
  constructor(options) {
    options.icon = options.icon || false;
    options.area = options.area || svs.components.dialog.area.CONTEXTUAL;
    super(options);
    this.log = new svs.core.log.Logger('DialogContextual');
    this.zIndex = this.options.zIndex || 140;
  }

  render() {
    super.render();
    this._arrowEl = document.createElement('div');
    this._arrowEl.className += 'arrow';
    this.el.appendChild(this._arrowEl);
    this.addPopper();
  }

  addPopper() {
    let attachTo = this.options.attachTo;

    if (attachTo instanceof jQuery && attachTo.length > 0) {
      attachTo = attachTo[0];
    }

    createPopper(attachTo, this.el, {
      placement: 'bottom',
      strategy: 'fixed',
      modifiers: [{
        name: 'arrow',
        enabled: true,
        options: {
          element: this._arrowEl
        }
      }, {
        name: 'offset',
        options: {
          offset: [0, 17]
        }
      }, {
        name: 'computeStyles',
        options: {
          gpuAcceleration: false,
          adaptive: false
        }
      }, {
        name: 'preventOverflow',
        options: {
          boundary: 'window',
          padding: 12
        }
      }]
    });
  }

  setupAnimations() {
    this.tl = new TimelineLite({
      paused: true,
      onComplete: () => {
        this.hasRevealed();
      },
      onReverseComplete: () => {
        this.hasClosed();
      }
    });
    this.tl.add(TweenLite.fromTo(this.el, 0.2, {
      scale: 0.8,
      opacity: 0
    }, {
      scale: 1,
      opacity: 1
    }));
    this.tl.add(TweenLite.fromTo(this.el, 0.2, {
      boxShadow: '0'
    }, {
      boxShadow: '0 0 48px 4px rgba(0, 0, 0, .5)'
    }), '-=.1');
    this.tl.add(new TweenLite.fromTo(this._content, 0.2, {
      autoAlpha: 0
    }, {
      autoAlpha: 1
    }));
    this.tl.add(new TweenLite.fromTo(this._buttons, 0.2, {
      opacity: 0,
      y: 50
    }, {
      opacity: 1,
      y: 0
    }), '-=.1');
  }

}

svs.components.dialog.Contextual = DialogContextual;
 })(window);